<div class="scheduler-week-container" >
  <ng-container *ngIf="isLoaded">
  <div class="scheduler-week-container__day">{{educateurFirstName}}</div>
  <app-scheduler-day class="scheduler-week-container__day" [dayEvent]="filterByDay(day.getDate())" *ngFor="let day of this.period.getDaysOfPeriod()"></app-scheduler-day>
  </ng-container>
</div>
